import type { TableColumn } from "../../../../../../components/table";

export const tableColumns: TableColumn<any>[] = [
  {
    title: "STT",
    size: "medium",
    renderCell: (row, index) => index,
  },
  {
    title: "Người sử dụng",
    size: "medium",
    renderCell: (row) => row.Users,
  },
  {
    title: "Mã nhân viên",
    renderCell: (row) => row.NameSupplies,
  },
  {
    title: "Bộ phận công tác",
    renderCell: (row) => row.WorkingDepartment,
  },
  {
    title: "Chức danh",
    renderCell: (row) => row.Title,
  },
  {
    title: "Đề nghị",
    size: "medium",
    renderCell: (row) => row.Suggestions,
  },
  {
    title: "Chi tiết đề nghị",
    size: "large",
    renderCell: (row) => row.SuggestionDetails,
  },
  {
    title: "Lý do/trình độ đào tạo",
    renderCell: (row) => row.DegreeTraining,
  },
  {
    title: "Email",
    size: "large",
    renderCell: (row) => row.Email,
  },
  {
    title: "Số điện thoại",
    renderCell: (row) => row.PhoneNumber,
  },
];
